import i18n from '@fiverr/i18n/singleton';
import type { DisplayableCardInfo, EagerJobInfo, GetJobInfoArgs, ShouldNotDisplayCard } from '@fiverr-private/jtbd_sdk';
import pathfinder from '@fiverr-private/pathfinder';
import { ICON_URL } from '../constants';
import { shouldShowCard } from './shouldShowCard';
import { fetchBusinessInfo } from './fetchBusinessInfo';

const doNotShowTemplate: ShouldNotDisplayCard = {
    shouldDisplayJob: false,
};

const TTL_60_DAYS = 60;

const getDisplayCardConfig = ({ locale, userId }): EagerJobInfo => ({
    shouldDisplayJob: true,
    dismissInfo: {
        isDismissible: true,
        jtbdTTL: TTL_60_DAYS,
    },

    headerText: i18n.t('jobs_tbd.project_management.header_text', { $scope: locale }),
    jobPages: [
        {
            iconUrl: ICON_URL,
            title: i18n.t('jobs_tbd.project_management.title', { $scope: locale }),
            subtitle: i18n.t('jobs_tbd.project_management.subtitle', { $scope: locale }),
            biEnrichment: {
                user: {
                    id: userId,
                },
                page: {
                    element: {
                        name: 'JTBD_seamless_migration',
                    },
                },
            },
        },
    ],
    clickAction: {
        type: 'link',
        href: pathfinder(
            'fiverr_pro_product_page',
            { slug: 'project-management-service' },
            { query: { source: 'fiverr_lihp' } }
        ),
    },
});

export const getJobInfo = async ({
    context,
    externalServicesInfo,
}: GetJobInfoArgs): Promise<ShouldNotDisplayCard | DisplayableCardInfo> => {
    const { locale, userId, countryCode } = context;

    const displayCardConfig = getDisplayCardConfig({ locale, userId });

    const federationPegasusUrl = externalServicesInfo?.federationPegasus?.url;

    const businessInfo = await fetchBusinessInfo(federationPegasusUrl, userId as number);

    const showForRNC = shouldShowCard({
        companySize: businessInfo.companySize,
        purposes: businessInfo.purposes,
        avgOrderAmount: businessInfo.avgOrderAmount,
        countryCode,
    });

    return showForRNC ? displayCardConfig : doNotShowTemplate;
};
